import React from "react";
import {
  FaClock,
  FaCalendarAlt,
  FaCogs,
  FaUsers,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";

function Policies() {
  const policyTypes = [
    {
      id: "attendance",
      title: "Attendance Policies",
      description: "Working hours, reporting time, weekends, and holidays",
      icon: <FaClock className="text-white fs-4" />,
      color: "bg-primary",
      link: "/attendance-policies",
      features: [
        "Working Hours",
        "Late Policies",
        "Weekend Settings",
        "Holiday Management",
      ],
    },

    {
      id: "leave",
      title: "Leave Policies",
      description: "Annual leave, sick leave, and special leave management",
      icon: <FaCalendarAlt className="text-white fs-4" />,
      color: "bg-info",
      link: "/leave-policies",
      features: [
        "Annual Leave",
        "Sick Leave",
        "Emergency Leave",
        "Leave Approval",
      ],
    },
  ];

  return (
    <>
      <header className="border-bottom bg-light">
        <div className="container px-4 py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <h1 className="h3 fw-bold">HR Policy Management</h1>
              <p className="text-muted small">
                Configure and manage all HR policies across branches
              </p>
            </div>
          </div>
        </div>
      </header>

      <div className="container px-4 py-3">
        <div className="d-flex gap-2">
          {policyTypes.map((policyType) => (
            <div key={policyType.id} className="col-md-6 mb-4">
              <Link
                to={policyType.link}
                className="text-decoration-none text-dark"
              >
                <div
                  className="card h-100 border shadow-sm"
                  style={{ cursor: "pointer" }}
                >
                  <div className="card-header bg-white border-bottom-0">
                    <div className="d-flex align-items-start justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        <div className={`p-3 rounded ${policyType.color}`}>
                          {policyType.icon}
                        </div>
                        <div>
                          <h5 className="card-title mb-1">
                            {policyType.title}
                          </h5>
                          <p className="card-text small text-muted">
                            {policyType.description}
                          </p>
                        </div>
                      </div>
                      <FaArrowRight className="text-muted fs-5" />
                    </div>
                  </div>

                  <div className="card-body">
                    <p className="small fw-medium mb-2">Key Features:</p>
                    <div className="d-flex flex-wrap gap-2">
                      {policyType.features.map((feature, index) => (
                        <span
                          key={index}
                          className="badge bg-light border text-dark"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Policies;
